import { CardDisclosure } from './card-disclosure';
import { CardId } from './card-id';
import { CardDisclosureStatus } from '../logic-types';

export class CardIndexMapping {
  private indexMapping: Map<number, CardDisclosure>;

  public get allCardsDisclosed(): boolean {
    return Array.from(this.indexMapping.values()).every(
      (item) => item.disclosureStatus === CardDisclosureStatus.Completed,
    );
  }

  public get disclosedCardCount(): number {
    return Array.from(this.indexMapping.values()).filter(
      (item) => item.disclosureStatus === CardDisclosureStatus.Completed,
    ).length;
  }

  constructor() {
    this.indexMapping = new Map<number, CardDisclosure>();
  }

  public cardIdForIndex(index: number): CardId | undefined {
    const result = this.getCardIndex(index);
    return result?.cardId;
  }

  public resetDeck(): void {
    for (let index = 0; index < 52; ++index) {
      this.addCardIndex(index, new CardDisclosure(CardDisclosureStatus.None));
    }
  }

  public dealDeck(indexes: number[], ids: string[]): void {
    for (let index = 0; index < indexes.length; ++index) {
      const cardId = new CardId(ids[index]);
      this.addCardIndex(indexes[index], new CardDisclosure(CardDisclosureStatus.Completed, cardId));
    }
  }

  public setStatusWhenNoneForIndex(cardIndex: number, status: CardDisclosureStatus): void {
    const cardDisclosureStatus = this.getCardIndex(cardIndex);
    if (cardDisclosureStatus?.disclosureStatus === CardDisclosureStatus.None) {
      cardDisclosureStatus.disclosureStatus = status;
    }
  }

  public setStatusWhenPendingForIndex(cardIndex: number, status: CardDisclosureStatus): boolean {
    const cardDisclosureStatus = this.getCardIndex(cardIndex);
    if (cardDisclosureStatus?.disclosureStatus === CardDisclosureStatus.Pending) {
      cardDisclosureStatus.disclosureStatus = status;
      return true;
    }
    return false;
  }

  private addCardIndex(index: number, card: CardDisclosure): void {
    this.indexMapping.set(index, card);
  }

  private getCardIndex(index: number): CardDisclosure | undefined {
    return this.indexMapping.get(index);
  }
}
